import { jsx as s } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import e from "classnames";
import { BASE_CLASS as m, LOADING_CLASS as a, MARGIN_CLASS as S } from "./constants.js";
/* empty css                    */
const n = ({ hasMargin: o = !1, isLoading: t = !1, width: r }) => /* @__PURE__ */ s("span", { className: e(m, { [a]: t, [S]: o }), style: { width: r } });
export {
  n as AmountSkeleton,
  n as default
};
